import React, { PropsWithChildren, createContext, useContext, useEffect, useState } from "react";
import { ROLE } from "../../utils/roles";
import { IUser } from "../api/types";
import { useNavigate } from "react-router-dom";

type AuthProviderProps = PropsWithChildren & {
    isSignedIn?: boolean
};

export const AuthContext = createContext<IUser | null>(null);

export default function AuthProvider({ children, isSignedIn }: AuthProviderProps) {

    const lUser = localStorage.getItem('user') ?? `{"roles": [], "token": "" }`
   
    const localStorageUser: IUser = JSON.parse(lUser === '' ? `{"roles": [], "token": "" }` : lUser)

    const [user] = useState<IUser | null>(localStorageUser);

    return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>
};

export const useAuth = () => {

    const context = useContext(AuthContext)

    if (context === undefined) {
        throw new Error('Use Auth must be used in the Provider')
    }

    return context
}